import React, { FunctionComponent } from "react";

import { useLanguage } from "../../../i18n/useLanguage";
import { useDealerAccountInfo } from "../../../stores/hooks/useDealerAccountInfo";

export const CartLegalInfo: FunctionComponent = () => {
  const [language] = useLanguage();
  const { dealerCarousels, legalFooter } = useDealerAccountInfo();
  const src =
    dealerCarousels.order_summary[0]?.imageURL[language] ||
    dealerCarousels.order_summary[0]?.imageURL["en"];

  const text = legalFooter[language];
  return (
    text && (
      <section className="border rounded-panel p-4">
        {src && (
          <img
            alt="legal footer"
            className="mix-blend-multiply mb-2"
            src={src}
          />
        )}
        <p className="text-sm">{text}</p>
      </section>
    )
  );
};
